import styled from 'styled-components'

export const Container = styled.section`
	margin: 0;
	background: ${props => props.theme.main};
`